import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialSpeedPage() {
    const navigate = useNavigate();
    const [racing, setRacing] = useState(false);
    const [finished, setFinished] = useState(false);

    const startRace = () => {
        setRacing(true);
        setFinished(false);
        setTimeout(() => {
            setFinished(true);
        }, 3000);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

            <h1 style={{ fontSize: '3rem', fontWeight: 900, fontStyle: 'italic', marginBottom: 10 }}>🏎️ Speed Racer</h1>
            <p style={{ opacity: 0.6, fontSize: '1.2rem', marginBottom: 60 }}>Google ne pardonne pas la lenteur.</p>

            <div style={{ width: '100%', maxWidth: 1000, position: 'relative' }}>

                {/* Track 1: Competitor */}
                <div style={{ marginBottom: 40, position: 'relative' }}>
                    <div style={{ fontSize: '1rem', marginBottom: 5, color: '#94a3b8' }}>🐢 Site Classique (Wix/Wordpress mal configuré)</div>
                    <div style={{ height: 60, background: '#1e293b', borderRadius: 8, position: 'relative', overflow: 'hidden' }}>
                        <div style={{
                            position: 'absolute', top: 5, left: 0, fontSize: '2.5rem',
                            transition: racing ? 'left 5s linear' : 'none',
                            left: finished ? '60%' : '0%' // Competitor is slow, only reaches 60%
                        }}>
                            🚗
                        </div>
                        {/* Finish Line */}
                        <div style={{ position: 'absolute', right: 20, top: 0, bottom: 0, width: 5, background: 'repeating-linear-gradient(45deg, white, white 10px, black 10px, black 20px)', opacity: 0.3 }} />
                    </div>
                </div>

                {/* Track 2: InfoColab */}
                <div style={{ marginBottom: 40, position: 'relative' }}>
                    <div style={{ fontSize: '1rem', marginBottom: 5, color: '#3b82f6', fontWeight: 700 }}>🚀 Site InfoColab (Next.js Optimisé)</div>
                    <div style={{ height: 60, background: '#1e293b', borderRadius: 8, position: 'relative', overflow: 'hidden', boxShadow: '0 0 20px rgba(59, 130, 246, 0.2)' }}>
                        <div style={{
                            position: 'absolute', top: 5, left: 0, fontSize: '2.5rem',
                            transition: racing ? 'left 1s cubic-bezier(0.2, 0.8, 0.2, 1)' : 'none', // Super fast
                            left: finished ? '92%' : '0%'
                        }}>
                            🏎️
                        </div>
                        {/* Finish Line */}
                        <div style={{ position: 'absolute', right: 20, top: 0, bottom: 0, width: 5, background: 'repeating-linear-gradient(45deg, white, white 10px, black 10px, black 20px)' }} />
                    </div>
                </div>

                {finished && (
                    <div className="animate-pop" style={{ textAlign: 'center', marginTop: 40 }}>
                        <div style={{ display: 'inline-block', padding: '20px 40px', background: '#22c55e', color: 'white', borderRadius: 20, boxShadow: '0 10px 40px rgba(34, 197, 94, 0.4)' }}>
                            <div style={{ fontSize: '1.2rem', fontWeight: 700 }}>TEMPS DE CHARGEMENT</div>
                            <div style={{ fontSize: '3rem', fontWeight: 900 }}>0.4s ⚡️</div>
                            <div style={{ fontSize: '0.9rem' }}>vs 4.2s chez le concurrent</div>
                        </div>
                        <div style={{ marginTop: 20, fontSize: '1.5rem', fontWeight: 700 }}>
                            « La vitesse, c'est du C.A. »
                        </div>
                    </div>
                )}
            </div>

            {!racing && !finished && (
                <button
                    onClick={startRace}
                    style={{
                        marginTop: 50, padding: '20px 60px', borderRadius: 50, border: 'none',
                        background: 'linear-gradient(90deg, #ef4444, #f97316)', color: 'white',
                        fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer',
                        boxShadow: '0 10px 30px rgba(239, 68, 68, 0.4)'
                    }}
                >
                    LANCER LA COURSE 🏁
                </button>
            )}

            {finished && (
                <button onClick={() => { setRacing(false); setFinished(false); }} style={{ marginTop: 40, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>Rejouer</button>
            )}
            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, right: 30, background: 'rgba(255,255,255,0.1)', padding: '10px 20px', borderRadius: 50, border: 'none', color: 'white', cursor: 'pointer' }}>Quitter</button>

            <style>{`.animate-pop { animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); } @keyframes popIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
        </div>
    );
}
